import { getFileNameFromContentDisposition } from '@/shared/utils/getFileNameFromContentDisposition';
import HttpClientAdapter from '@/shared/services/httpClientAdapter';

export interface TemplateDownload {
  blob: Blob;
  fileName?: string;
}

class FilesService extends HttpClientAdapter {
  constructor() {
    super('FILES');
  }

  processSheet<Response>(params: FormData, layoutType: string) {
    return this.post<Response, FormData>(`/process-sheet/${layoutType}`, params);
  }

  sendCadastralPosition<Response>(params: FormData) {
    return this.post<Response, FormData>('/cadastral-positions', params);
  }

  sendLeadIndication<Response>(params: FormData) {
    return this.post<Response, FormData>('/indications', params);
  }

  /**
   * Baixa o template vigente via `GET /templates/:type/download` (endpoint
   * autenticado do sov-v2-files). A resposta é binária (`responseType: 'blob'`)
   * e o nome do arquivo é extraído do header `Content-Disposition`, com fallback
   * para o `fallbackFileName` informado caso o header não esteja acessível.
   *
   * Usa a instância axios da base (com base URL e interceptors de auth já
   * configurados), pois precisamos acessar os headers da resposta — que o método
   * `request` padrão do adapter não expõe.
   */
  async downloadTemplate(type: string, fallbackFileName?: string): Promise<TemplateDownload> {
    const response = await this.getAxiosInstance().request<Blob>({
      url: this.getFullURL(`/templates/${type}/download`),
      method: 'get',
      responseType: 'blob',
    });

    const contentDisposition = response.headers?.['content-disposition'] as string | undefined;
    const fileName = getFileNameFromContentDisposition(contentDisposition, fallbackFileName);

    return {
      blob: response.data,
      fileName,
    };
  }
}

export default FilesService;
